<template>
  <div class="container py-10">
    <div class="flex items-center mb-10">
      <a href="/admin/forms/qualify-credentials" class="text-gray-900 no-underline">
        <d-icon icon="arrow-left" size="1x" class="mr-3" />
        <span class="text-xl">Back To Listing Page</span>
      </a>
    </div>

    <div class="flex flex-wrap -mx-5">
      <div class="px-5 w-full md:w-1/2">
        <h2>Primary Request Contact</h2>
        <div v-if="computedRevisedPrimaryRequestContact">
          <div class="mb-3">
            <p class="font-bold">
              Type of Recipient
            </p>
            <p v-text="computedSubmissionDetails.revisedPrimaryRequestTypeOfRecipient" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              First Name
            </p>
            <p v-text="computedRevisedPrimaryRequestContact.firstName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Last Name
            </p>
            <p v-text="computedRevisedPrimaryRequestContact.lastName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Email
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.email" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Fax #
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.fax" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Company Name
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.name" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 1
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.addressLine1" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 2
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.addressLine2" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              City
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.city" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              State
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.state" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Zip/Postal
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.zip" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Country
            </p>
            <p v-text="computedRevisedPrimaryRequestCompany.country" />
          </div>
        </div>
        <div v-else>
          <p>
            No information was submitted for this contact.
          </p>
        </div>
      </div>

      <div class="px-5 w-full md:w-1/2">
        <h2>Secondary Request Contact</h2>
        <div v-if="computedRevisedSecondaryRequestContact">
          <div class="mb-3">
            <p class="font-bold">
              Type of Recipient
            </p>
            <p v-text="computedSubmissionDetails.revisedSecondaryRequestTypeOfRecipient" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              First Name
            </p>
            <p v-text="computedRevisedSecondaryRequestContact.firstName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Last Name
            </p>
            <p v-text="computedRevisedSecondaryRequestContact.lastName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Email
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.email" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Fax #
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.fax" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Company Name
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.name" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 1
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.addressLine1" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 2
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.addressLine2" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              City
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.city" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              State
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.state" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Zip/Postal
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.zip" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Country
            </p>
            <p v-text="computedRevisedSecondaryRequestCompany.country" />
          </div>
        </div>
        <div v-else>
          <p>
            No information was submitted for this contact.
          </p>
        </div>
      </div>
    </div>

    <hr>

    <div class="flex flex-wrap -mx-5">
      <div class="px-5 w-full md:w-1/2">
        <h2>Third Request Contact</h2>
        <div v-if="computedRevisedThirdRequestContact">
          <div class="mb-3">
            <p class="font-bold">
              Type of Recipient
            </p>
            <p v-text="computedSubmissionDetails.revisedThirdRequestTypeOfRecipient" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              First Name
            </p>
            <p v-text="computedRevisedThirdRequestContact.firstName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Last Name
            </p>
            <p v-text="computedRevisedThirdRequestContact.lastName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Email
            </p>
            <p v-text="computedRevisedThirdRequestCompany.email" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Fax #
            </p>
            <p v-text="computedRevisedThirdRequestCompany.fax" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Company Name
            </p>
            <p v-text="computedRevisedThirdRequestCompany.name" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 1
            </p>
            <p v-text="computedRevisedThirdRequestCompany.addressLine1" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Address Line 2
            </p>
            <p v-text="computedRevisedThirdRequestCompany.addressLine2" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              City
            </p>
            <p v-text="computedRevisedThirdRequestCompany.city" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              State
            </p>
            <p v-text="computedRevisedThirdRequestCompany.state" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Zip/Postal
            </p>
            <p v-text="computedRevisedThirdRequestCompany.zip" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Country
            </p>
            <p v-text="computedRevisedThirdRequestCompany.country" />
          </div>
        </div>
        <div v-else>
          <p>
            No information was submitted for this contact.
          </p>
        </div>
      </div>

      <div class="px-5 w-full md:w-1/2">
        <h2>General Contractor Contact</h2>
        <div v-if="computedRevisedGeneralContractorContact">
          <div class="mb-3">
            <p class="font-bold">
              First Name
            </p>
            <p v-text="computedRevisedGeneralContractorContact.firstName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Last Name
            </p>
            <p v-text="computedRevisedGeneralContractorContact.lastName" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Email
            </p>
            <p v-text="computedRevisedGeneralContractorContact.email" />
          </div>
          <div class="mb-3">
            <p class="font-bold">
              Woodworking Firm
            </p>
            <p v-text="computedSubmissionDetails.revisedWoodworkingFirm" />
          </div>
        </div>
        <div v-else>
          <p>
            No information was submitted for this contact.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('update:submissionDetails', value);
        },
      },

      computedRevisedPrimaryRequestContact() {
        return this.computedSubmissionDetails.revisedPrimaryRequestContact;
      },
      computedRevisedPrimaryRequestCompany() {
        return this.computedSubmissionDetails.revisedPrimaryRequestCompany;
      },

      computedRevisedSecondaryRequestCompany() {
        return this.computedSubmissionDetails.revisedSecondaryRequestCompany;
      },
      computedRevisedSecondaryRequestContact() {
        return this.computedSubmissionDetails.revisedSecondaryRequestContact;
      },

      computedRevisedThirdRequestCompany() {
        return this.computedSubmissionDetails.revisedThirdRequestCompany;
      },
      computedRevisedThirdRequestContact() {
        return this.computedSubmissionDetails.revisedThirdRequestContact;
      },

      computedRevisedGeneralContractorContact() {
        return this.computedSubmissionDetails.revisedGeneralContractorContact;
      },
    },
  };
</script>